import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationData, NotificationService } from '../services/notification.service';
import { ThemeService } from '../services/themes.service';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
})

export class NotificationComponent implements OnInit {

    themeData: any;
    fontData: any;
    notification: NotificationData | null = null;
    private subscription!: Subscription;

    constructor(
        private themeService: ThemeService,
        private notificationService: NotificationService
    ) { }

    ngOnInit() {
        this.themeService.theme$.subscribe((response) => {
            this.themeData = response;
        });
        this.themeService.selectedFont$.subscribe((response) => {
            this.fontData = response;
        });

        this.subscription = this.notificationService.notification$.subscribe(data => {
            this.notification = data;
            setTimeout(() => this.closeNotification(), 5000);
        });
    }

    closeNotification() {
        this.notification = null;
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}